import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useFaq } from '../api/hooks';
import { Loader, ErrorView } from '../components/StateViews';
import { BlueHeader, HeaderBack } from '../components/ScreenShell';
import { backButton, haptics } from '../telegram';

export function FaqScreen() {
  const navigate = useNavigate();
  const { data, isLoading, isError, error } = useFaq();
  const [openId, setOpenId] = useState<number | null>(null);

  useEffect(() => {
    const back = () => navigate(-1);
    backButton.show(back);
    return () => backButton.hide(back);
  }, [navigate]);

  if (isLoading) return <Loader />;
  if (isError || !data) return <ErrorView message={(error as Error)?.message} />;

  return (
    <div>
      <BlueHeader>
        <div className="bhead-top" style={{ marginBottom: 0 }}>
          <HeaderBack onClick={() => navigate(-1)} />
          <div className="bhead-title bhead-title--sm" style={{ flex: 1 }}>
            Вопросы и ответы
          </div>
        </div>
      </BlueHeader>

      <div className="content">
        {data.length === 0 ? (
          <div className="muted tiny" style={{ marginTop: 12 }}>
            Здесь пока пусто — вопросы появятся позже.
          </div>
        ) : (
          <div className="list-card" style={{ marginTop: 4 }}>
            {data.map((item) => {
              const open = openId === item.id;
              return (
                <div key={item.id} className="faq-item">
                  <button
                    className="faq-q"
                    aria-expanded={open}
                    onClick={() => {
                      haptics.tap();
                      setOpenId(open ? null : item.id);
                    }}
                  >
                    <span className="faq-q-text">{item.question}</span>
                    <span className={`faq-chev${open ? ' faq-chev--open' : ''}`}>›</span>
                  </button>
                  {open && <div className="faq-a">{item.answer}</div>}
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
